//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationProvider } from 'vee-validate'
import { rutFilter } from 'vue-dni'
import Multiselect from 'vue-multiselect'
import FormLabel from '~/components/Form/FormLabel'

const CHILEAN_CODE = 'CHL'

const ID_TYPES = {
  rut: 'rut',
  identification_number: 'identification_number',
  email: 'email',
  phone: 'phone',
}

const VALIDATION_RULES = {
  rut: 'required|checkRut',
  identification_number: 'required',
  email: 'required|email',
  phone: 'required|internationalPhone',
}

const PLACEHOLDERS = {
  rut: '11111111-1',
  identification_number: 'Ej: 70123456',
  email: 'Ej: usuario@gmail.com',
  phone: 'Ej: +56987689876',
}
const FIELDS = {
  rut: 'RUT / Identificador',
  identification_number: 'Número de documento / Identificador',
  email: 'Email',
  phone: 'Teléfono',
}

const OPTIONS = {
  [ID_TYPES.identification_number]: 'Nº de documento / Identificador',
  [ID_TYPES.email]: FIELDS.email,
  [ID_TYPES.phone]: FIELDS.phone,
}

export default {
  name: 'FormInput',
  components: {
    FormLabel,
    ValidationProvider,
    Multiselect,
  },
  props: {
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
    ignoreValidGreen: {
      type: Boolean,
      default: false,
    },
    hideOptions: {
      type: Boolean,
      default: false,
    },
  },
  async fetch() {
    this.countries = await this.$repository.location.find(
      { type: 'country', region: 'Americas', _limit: -1 },
      []
    )
  },
  data: () => ({
    FIELDS,
    ID_TYPES,
    OPTIONS,
    innerValue: '',
    init: false,
    identificatorType: ID_TYPES.identification_number,
    type: null,
    countries: [],
  }),
  computed: {
    fieldType() {
      if (this.identificatorType === ID_TYPES.identification_number) {
        return this.type?.code === CHILEAN_CODE
          ? ID_TYPES.rut
          : ID_TYPES.identification_number
      }
      return this.identificatorType
    },
    computedRules() {
      return VALIDATION_RULES[this.fieldType] || this.rules
    },
    computedPlaceholder() {
      return PLACEHOLDERS[this.fieldType] || this.$attrs.placeholder
    },
    computedLabel() {
      return FIELDS[this.fieldType] || 'Número'
    },
  },
  watch: {
    innerValue(newVal) {
      if (this.fieldType === ID_TYPES.rut) {
        this.innerValue = rutFilter(newVal)
      }
      this.$emit('input', newVal)
      this.init = true
    },
    value(newVal) {
      this.innerValue = newVal
      this.init = true
    },
    identificatorType() {
      this.innerValue = ''
      this.init = false
      this.$emit('identificator-type-change', this.identificatorType)
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  mounted() {
    this.$emit('set-custom-errors', this.setErrors)
  },
  methods: {
    iconRightClick(event) {
      this.$emit('icon-right-click', event)
    },
    onBlur(event) {
      this.$emit('blur', event)
    },
    setErrors(listErrors) {
      this.$refs.provider.applyResult({
        errors: listErrors,
        valid: false,
        failedRules: {},
      })
    },
  },
}
